(function () {
  var TAG = 'perso-prenom';
  var PROPERTY_NAME = 'Personnalisation (flocage)';
  var ADDON = {
    prenom: {
      variantId: 58732531286351,
      radioLabel: 'Prénom complet (+7,00 €)',
      propertyLabel: 'Prénom complet',
      fieldLabel: 'Prénom à floquer',
      maxLength: 15,
      placeholder: 'Ex : Camille'
    }
  };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function buildField(productTitle) {
    var wrapper = document.createElement('div');
    wrapper.className = 'product-form__input perso-prenom';
    wrapper.innerHTML =
      '<style>' +
      '.perso-prenom{margin-top:1.2rem;}' +
      '.perso-prenom__box{border:2px solid rgba(var(--color-foreground),.18);border-radius:.6rem;padding:1.2rem 1.4rem;background:rgba(var(--color-foreground),.03);}' +
      '.perso-prenom__legend{display:block;font-size:1.4rem;font-weight:700;margin-bottom:.9rem;}' +
      '.perso-prenom__opt{display:flex;align-items:center;gap:1rem;cursor:pointer;font-size:1.5rem;font-weight:600;padding:.9rem 1.1rem;border:2px solid rgba(var(--color-foreground),.3);border-radius:.5rem;margin-bottom:.7rem;transition:background .15s,border-color .15s;}' +
      '.perso-prenom__opt:last-of-type{margin-bottom:0;}' +
      '.perso-prenom__opt input{width:2.2rem;height:2.2rem;margin:0;flex:none;accent-color:rgb(var(--color-foreground));}' +
      '.perso-prenom__opt.is-checked{background:rgba(var(--color-foreground),.08);border-color:rgba(var(--color-foreground),.7);}' +
      '.perso-prenom__field{margin-top:1rem;}' +
      '.perso-prenom__field label{display:block;font-size:1.2rem;margin-bottom:.4rem;}' +
      '.perso-prenom__field input[type="text"]{width:100%;max-width:32rem;padding:.8rem 1rem;border:1px solid rgba(var(--color-foreground),.3);font-size:1.4rem;font-family:inherit;}' +
      '.perso-prenom__hint{display:block;font-size:1.1rem;color:rgba(var(--color-foreground),.65);margin-top:.4rem;}' +
      '.perso-prenom__confirm{display:flex;align-items:flex-start;gap:.6rem;cursor:pointer;font-size:1.2rem;margin-top:.8rem;}' +
      '.perso-prenom__confirm input{width:1.6rem;height:1.6rem;margin:.2rem 0 0;flex:none;}' +
      '</style>' +
      '<div class="perso-prenom__box">' +
      '<span class="perso-prenom__legend">Personnaliser cet article ?</span>' +
      '<label class="perso-prenom__opt"><input type="checkbox" class="perso-prenom__opt-checkbox" data-choice="prenom"><span>' +
      ADDON.prenom.radioLabel +
      '</span></label>' +
      '<div class="perso-prenom__field" hidden>' +
      '<label class="perso-prenom__field-label"></label>' +
      '<input type="text" class="perso-prenom__text">' +
      '<span class="perso-prenom__hint"></span>' +
      '<label class="perso-prenom__confirm"><input type="checkbox" class="perso-prenom__confirm-input"><span>Je confirme l\'orthographe du texte ci-dessus (les articles floqués sont personnalisés et ne sont ni repris ni échangés)</span></label>' +
      '</div>' +
      '</div>';

    var optCheckboxes = wrapper.querySelectorAll('.perso-prenom__opt-checkbox');
    var field = wrapper.querySelector('.perso-prenom__field');
    var fieldLabel = wrapper.querySelector('.perso-prenom__field-label');
    var hint = wrapper.querySelector('.perso-prenom__hint');
    var textInput = wrapper.querySelector('.perso-prenom__text');
    var confirmCheckbox = wrapper.querySelector('.perso-prenom__confirm-input');

    function applyChoice(choice) {
      confirmCheckbox.checked = false;
      if (choice === 'aucune') {
        field.hidden = true;
        textInput.required = false;
        textInput.value = '';
        return;
      }
      var opt = ADDON[choice];
      field.hidden = false;
      fieldLabel.textContent = opt.fieldLabel;
      textInput.maxLength = opt.maxLength;
      textInput.placeholder = opt.placeholder;
      hint.textContent = opt.maxLength + ' caractères maximum';
      textInput.required = true;
      textInput.value = '';
      textInput.focus();
    }

    Array.prototype.forEach.call(optCheckboxes, function (checkbox) {
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) {
          Array.prototype.forEach.call(optCheckboxes, function (other) {
            if (other !== checkbox) {
              other.checked = false;
              other.closest('.perso-prenom__opt').classList.remove('is-checked');
            }
          });
          checkbox.closest('.perso-prenom__opt').classList.add('is-checked');
          applyChoice(checkbox.getAttribute('data-choice'));
        } else {
          checkbox.closest('.perso-prenom__opt').classList.remove('is-checked');
          applyChoice('aucune');
        }
      });
    });

    textInput.addEventListener('input', function () {
      confirmCheckbox.checked = false;
    });

    return wrapper;
  }

  function showError(form, message) {
    var wrapper = form.querySelector('.product-form__error-message-wrapper');
    if (!wrapper) {
      if (message) window.alert(message);
      return;
    }
    var messageEl = wrapper.querySelector('.product-form__error-message');
    wrapper.hidden = !message;
    if (messageEl) messageEl.textContent = message || '';
  }

  function submitWithAddon(form, fieldWrapper, choice, text, productTitle) {
    var opt = ADDON[choice];
    var fd = new FormData(form);
    var mainVariantId = fd.get('id');
    var quantity = parseInt(fd.get('quantity'), 10) || 1;

    var mainProperties = {};
    fd.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) mainProperties[match[1]] = value;
    });
    mainProperties[PROPERTY_NAME] = opt.propertyLabel + ' : ' + text;

    var addonProperties = {
      'Article concerné': productTitle || '',
      Personnalisation: opt.propertyLabel + ' : ' + text
    };

    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.setAttribute('aria-disabled', 'true');
    showError(form, '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          { id: mainVariantId, quantity: quantity, properties: mainProperties },
          { id: opt.variantId, quantity: quantity, properties: addonProperties }
        ]
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var message =
            (result.data && (result.data.description || result.data.message)) ||
            "Une erreur est survenue lors de l'ajout au panier, merci de réessayer.";
          showError(form, message);
          if (submitButton) submitButton.removeAttribute('aria-disabled');
          return;
        }
        window.location = window.routes.cart_url;
      })
      .catch(function () {
        showError(form, 'Une erreur réseau est survenue, merci de réessayer.');
        if (submitButton) submitButton.removeAttribute('aria-disabled');
      });
  }

  function attachSubmitInterceptor(form, fieldWrapper, productTitle) {
    document.addEventListener(
      'submit',
      function (evt) {
        if (evt.target !== form) return;

        var checked = fieldWrapper.querySelector('.perso-prenom__opt-checkbox:checked');
        var choice = checked ? checked.getAttribute('data-choice') : 'aucune';
        if (choice === 'aucune') return; // Let the theme's normal add-to-cart flow run untouched.

        var textInput = fieldWrapper.querySelector('.perso-prenom__text');
        var text = (textInput.value || '').trim();
        if (!text) {
          evt.preventDefault();
          evt.stopPropagation();
          showError(form, 'Merci de renseigner le texte à floquer.');
          textInput.focus();
          return;
        }

        var confirmCheckbox = fieldWrapper.querySelector('.perso-prenom__confirm-input');
        if (!confirmCheckbox || !confirmCheckbox.checked) {
          evt.preventDefault();
          evt.stopPropagation();
          showError(form, "Merci de confirmer l'orthographe en cochant la case avant d'ajouter au panier.");
          if (confirmCheckbox) confirmCheckbox.focus();
          return;
        }

        evt.preventDefault();
        evt.stopPropagation();
        submitWithAddon(form, fieldWrapper, choice, text, productTitle);
      },
      true
    );
  }

  function injectField(product) {
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    var form = productInfo.querySelector('form[data-type="add-to-cart-form"]');
    if (!form || form.querySelector('.perso-prenom')) return;

    var wrapper = buildField(product.title);
    var buttonsRow = form.querySelector('.product-form__buttons');
    if (buttonsRow && buttonsRow.parentNode) {
      buttonsRow.parentNode.insertBefore(wrapper, buttonsRow);
    } else {
      form.appendChild(wrapper);
    }

    attachSubmitInterceptor(form, wrapper, product.title);
  }

  function watchForRerender(product) {
    var productInfo = document.querySelector('product-info');
    if (!productInfo || !window.MutationObserver) return;
    var timer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        injectField(product);
      }, 50);
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  }

  ready(function () {
    var handle = getProductHandle();
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        if (!product || !product.tags) return;
        var tags = product.tags.map(function (t) {
          return String(t).toLowerCase();
        });
        if (tags.indexOf(TAG) === -1) return;
        injectField(product);
        watchForRerender(product);
      })
      .catch(function () {});
  });
})();
